import { PLAYLISTS_PATH, TITLES_PATH } from "../services/postAuthRouting";

// The one list of what is beta. The left nav and the pages themselves both
// read it, so they cannot drift apart, and promoting something out of beta is
// deleting a line here rather than hunting for badges.
export const BETA_PATHS = new Set([
  "/content",
  PLAYLISTS_PATH,
  "/inssa-live",
  TITLES_PATH,
  "/tv-rails",
]);

export const isBetaPath = (path) => BETA_PATHS.has(String(path || "").trim());
